/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "安全(Security)"
    }), "\n", _jsx(_components.p, {
      children: "¥Security"
    }), "\n", _jsx(_components.p, {
      children: "由于样式组件允许你使用任意输入作为插值，因此你必须小心清理该输入。使用用户输入作为样式可能会导致任何 CSS 在用户浏览器中被评估，攻击者可以将其放入你的应用中。"
    }), "\n", _jsx(_components.p, {
      children: "¥Since styled-components allows you to use arbitrary input as interpolations, you must be\ncareful to sanitize that input. Using user input as styles can lead to any CSS being evaluated in the user's\nbrowser that an attacker can place in your application."
    }), "\n", _jsx(_components.p, {
      children: "此示例显示错误的用户输入甚至可能导致代表用户调用 API 端点。"
    }), "\n", _jsx(_components.p, {
      children: "¥This example shows how bad user input can even lead to API endpoints being called on a user's\nbehalf."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "// Oh no! The user has given us a bad URL!\nconst userInput = '/api/withdraw-funds'\n\nconst ArbitraryComponent = styled.div`\n  background: url(${userInput});\n  /* More styles here... */\n`\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "要特别小心！这显然是一个虚构的例子，但 CSS 注入可能并不明显并且会产生不良影响。某些 IE 版本甚至在 url 声明中执行任意 JavaScript。"
    }), "\n", _jsx(_components.p, {
      children: "¥Be very careful! This is obviously a made-up example, but CSS injection can be unobvious and\nhave bad repercussions. Some IE versions even execute arbitrary JavaScript within url declarations."
    }), "\n", _jsxs(_components.p, {
      children: ["有一个即将推出的标准，用于清理 JavaScript 中的 CSS，即 ", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/API/CSS/escape",
        children: _jsx(_components.code, {
          children: "CSS.escape"
        })
      }), "。跨浏览器的支持还不是很好，因此我们建议在你的应用中使用 ", _jsx(_components.a, {
        href: "https://github.com/mathiasbynens/CSS.escape",
        children: "填充由 Mathias Bynens 设计"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There is an upcoming standard to sanitize CSS from JavaScript, ", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/API/CSS/escape",
        children: _jsx(_components.code, {
          children: "CSS.escape"
        })
      }), ". It's not very well supported across browsers yet, so we recommend using the ", _jsx(_components.a, {
        href: "https://github.com/mathiasbynens/CSS.escape",
        children: "polyfill by Mathias Bynens"
      }), " in your app."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
